import { RegionType } from "graphql/generated";

export const LOCALE_ITEM = {
  region: "region",
  region_time: "region_time",
  delivery_time_slots: "delivery_time_slots"
};

export const LOCALE_TYPE_BY_COUNTRY = {
  [RegionType.Sg]: {
    [LOCALE_ITEM.region]: "sg",
    [LOCALE_ITEM.region_time]: "singapore_time",
    [LOCALE_ITEM.delivery_time_slots]: "3_hour_delivery"
  },
  [RegionType.Hk]: {
    [LOCALE_ITEM.region]: "hk",
    [LOCALE_ITEM.region_time]: "hongkong_time",
    [LOCALE_ITEM.delivery_time_slots]: "2_hour_delivery"
  },
  [RegionType.Jp]: {
    [LOCALE_ITEM.region]: "jp",
    [LOCALE_ITEM.region_time]: "japan_time",
    [LOCALE_ITEM.delivery_time_slots]: "2_hour_delivery"
  }
};
